// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Select = createStyle({});
